import toast from "react-hot-toast";
import { NavigateFunction } from "react-router-dom";
import CrossIcon from "../../assets/CrossIcon";
import CheckIcon from "../../assets/CheckIcon";
import RedAlertIcon from "../../assets/ReadAlertIcon";
interface LINK {
  label: string;
  link: string;
  isExternal?: boolean;
}
export const toastMessage = (message: string, isError: boolean, link?: LINK, navigate?: NavigateFunction) => {
  toast.dismiss();
  return isError ? toastErrorMessage(message, link, navigate) : toastSuccessMessage(message, link, navigate);
};

export const toastSuccessMessage = (message = "Success!", link?: LINK, navigate?: NavigateFunction) => {
  toast.dismiss();
  toast.success(
    (t) => (
      <div className="flex items-center justify-between w-full gap-2">
        <div className="flex flex-col gap-1">
          <span className="text-xs md:text-sm !leading-normal font-bold">{message}</span>
          {link &&
            (link.isExternal ? (
              <a href={link.link} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:text-blue-800 underline font-semibold">
                {link.label}
              </a>
            ) : (
              <button
                className="text-xs text-blue-600 hover:text-blue-800 underline text-left font-semibold"
                onClick={() => {
                  toast.dismiss(t.id);
                  if (navigate) {
                    navigate(link.link);
                  } else {
                    window.location.href = link.link;
                  }
                }}
              >
                {link.label}
              </button>
            ))}
        </div>
        <button onClick={() => toast.dismiss(t.id)} className=" py-1 hover:scale-105">
          <CrossIcon />
        </button>
      </div>
    ),
    {
      duration: 5000,
      position: "top-center",
      style: {
        width: "fit-content",
        maxWidth: "90%",
        padding: "12px",
      },
      icon: (
        <>
          <div className="gap-2 h-full flex items-center justify-center">
            <div className="bg-text-green rounded-50 h-full w-1"></div>
            <CheckIcon />
          </div>
        </>
      ),
    }
  );
};

export const toastErrorMessage = (message = "Error!", link?: LINK, navigate?: NavigateFunction) => {
  toast.dismiss();
  toast.success(
    (t) => (
      <div className="flex items-center justify-between w-full flex-1 gap-2">
        <div className="flex flex-col gap-1">
          <span className="text-xs md:text-sm !leading-normal font-bold">{message}</span>
          {link &&
            (link.isExternal ? (
              <a href={link.link} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:text-blue-800 underline font-semibold">
                {link.label}
              </a>
            ) : (
              <button
                className="text-xs text-blue-600 hover:text-blue-800 underline text-left font-semibold"
                onClick={() => {
                  toast.dismiss(t.id);
                  if (navigate) {
                    navigate(link.link);
                  } else {
                    window.location.href = link.link;
                  }
                }}
              >
                {link.label}
              </button>
            ))}
        </div>
        <button onClick={() => toast.dismiss(t.id)} className=" py-1 hover:scale-105">
          <CrossIcon />
        </button>
      </div>
    ),
    {
      duration: 5000,
      position: "top-center",
      style: {
        width: "fit-content",
        maxWidth: "90%",
        padding: "12px",
      },
      icon: (
        <>
          <div className="gap-2 h-full flex items-center justify-center">
            <div className="bg-text-red rounded-50 h-full w-1"></div>
            <RedAlertIcon />
          </div>
        </>
      ),
    }
  );
};
